import { useCallback } from 'react';

import { Modal, ModalCancelButton, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { translationKeys } from '../../translations';

import { diagnosesToText } from './VisitDocumentsDiagnosesModal.utils';
import { VisitDocumentsDiagnosesForm } from './VisitDocumentsDiagnosesForm';
import { VisitDocumentsDiagnosesFormBean } from './VisitDocumentsDiagnosesForm.types';

type VisitDocumentsDiagnosesModalProps = Readonly<{
   onConfirm: (value: string) => void;
   onClose: VoidFunction;
}>;

export const VisitDocumentsDiagnosesModal = (props: VisitDocumentsDiagnosesModalProps): JSX.Element => {
   const handleOnValid = useCallback(
      ({ diagnoses }: VisitDocumentsDiagnosesFormBean) => {
         const value = diagnosesToText(diagnoses.value);

         if (value) {
            props.onConfirm(value);
         }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [props.onConfirm]
   );

   return (
      <Modal width={ModalWidth.NORMAL} testId={'visitDocumentsAddDiagnoses'} title={translationKeys.selectDiagnosis}>
         <VisitDocumentsDiagnosesForm>
            {({ handleSubmit }) => (
               <ModalConfirmButton label={translationKeys.add} onClick={handleSubmit(handleOnValid)} />
            )}
         </VisitDocumentsDiagnosesForm>
         <ModalCancelButton label={translationKeys.cancel} onClick={props.onClose} />
         <ModalCloseButton onClick={props.onClose} />
      </Modal>
   );
};
